import React from 'react';
import { BiPlus, BiSad } from 'react-icons/bi';
import { Link } from 'react-router-dom';

const PatientsNoDataBox = ({ message, buttonLabel, buttonLink }) => {
  return (
    <div className="flex flex-col items-center justify-center bg-gray-200 py-20">
      {/* Icon */}
      <div className="mb-4 flex items-center justify-center rounded-full bg-gray-200 p-6">
        <BiSad className="text-6xl text-gray-500" />
      </div>

      {/* Message */}
      <p className="mb-6 text-xl font-medium text-gray-600">{message}</p>

      {/* Add Button */}
      <Link
        to={buttonLink}
        className="hover:bg-subMain-dark flex items-center rounded-lg bg-subMain px-6 py-3 text-white shadow-md transition"
      >
        <BiPlus className="mr-2 inline-block" />
        {buttonLabel}
      </Link>
    </div>
  );
};

export default PatientsNoDataBox;
